import { Instagram, Linkedin } from "lucide-react";
import HeroSection from "@/components/HeroSection";
import SignsSection from "@/components/SignsSection";
import RiskSection from "@/components/RiskSection";
import HowWeActSection from "@/components/HowWeActSection";
import ApproachSection from "@/components/ApproachSection";
import TeamSection from "@/components/TeamSection";
import MesamindSection from "@/components/MesamindSection";
import CTASection from "@/components/CTASection";
import AnimatedSection from "@/components/AnimatedSection";

const Index = () => {
  return (
    <main className="overflow-x-hidden">
      <HeroSection />
      <AnimatedSection>
        <SignsSection />
      </AnimatedSection>
      <AnimatedSection delay={0.05}>
        <RiskSection />
      </AnimatedSection>
      <AnimatedSection delay={0.05}>
        <HowWeActSection />
      </AnimatedSection>
      <AnimatedSection delay={0.05}>
        <ApproachSection />
      </AnimatedSection>
      <AnimatedSection delay={0.05}>
        <TeamSection />
      </AnimatedSection>
      <AnimatedSection delay={0.05}>
        <MesamindSection />
      </AnimatedSection>
      <AnimatedSection delay={0.05}>
        <CTASection />
      </AnimatedSection>
      <footer className="section-darker py-8 border-t border-surface-dark">
        <div className="container mx-auto px-6 text-center">
          <p className="font-body text-[13px] font-semibold text-surface-darker-foreground/80 tracking-widest uppercase mb-3">
            Siga nossas redes
          </p>
          <div className="flex justify-center gap-4 mb-4">
            <a href="https://www.instagram.com/mesamind_/" target="_blank" rel="noopener noreferrer" className="text-surface-darker-foreground/60 hover:text-primary transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="https://www.linkedin.com/company/101223916/" target="_blank" rel="noopener noreferrer" className="text-surface-darker-foreground/60 hover:text-primary transition-colors">
              <Linkedin className="w-5 h-5" />
            </a>
          </div>
          <p className="font-body text-[13px] font-normal text-surface-darker-foreground/60 leading-[1.5em]">
            Mesamind © {new Date().getFullYear()} Todos os direitos reservados
          </p>
        </div>
      </footer>
    </main>
  );
};

export default Index;
